import { useTranslation } from 'react-i18next'

import { Flex } from '@/components/ui/flex'
import { Grid } from '@/components/ui/grid'

import { BlockCard } from './block-card'
import { SkeletonBlockItem } from './block-item'
import {
  ALL_SHORTCUT_TYPES,
  ALL_WIDGET_TYPES,
  BLOCKS_GRID_COLUMNS,
  MAX_ENABLED_SHORTCUTS,
} from './home-screen.constants'
import * as S from './home-screen.styled'

const SERVICES_SKELETON_ROWS = 5

const SkeletonList = ({ rows }: { rows: number }) => (
  <Flex direction="column" gap={8}>
    {Array.from({ length: rows }, (_, index) => (
      <SkeletonBlockItem key={index} />
    ))}
  </Flex>
)

export const HomeScreenSkeleton = () => {
  const { t } = useTranslation(['home-screen'])

  return (
    <S.ContentCard className="ctp-home-screen">
      <Grid columns={BLOCKS_GRID_COLUMNS} gap={20}>
        <BlockCard
          title={t('home-screen:labels.widgetsConfigurationHeader')}
          tooltip={t('home-screen:tooltips.widgetsConfiguration')}
        >
          <SkeletonList rows={ALL_WIDGET_TYPES.length} />
        </BlockCard>
        <BlockCard
          title={t('home-screen:labels.shortcutsConfigurationHeader')}
          tooltip={t('home-screen:tooltips.shortcutsConfiguration', { max: MAX_ENABLED_SHORTCUTS })}
        >
          <SkeletonList rows={ALL_SHORTCUT_TYPES.length} />
        </BlockCard>
        <BlockCard
          title={t('home-screen:labels.servicesConfigurationHeader')}
          tooltip={t('home-screen:tooltips.servicesConfiguration')}
        >
          <SkeletonList rows={SERVICES_SKELETON_ROWS} />
        </BlockCard>
      </Grid>
    </S.ContentCard>
  )
}
